class Branch {
  static MODULE = "branch";
  static LISTING = "branch.listing";
  static LISTING_READ = "branch.listing.read";
  static LISTING_WRITE = "branch.listing.write";
  static LISTING_WRITE_CREATE = "branch.listing.write.create";
  static LISTING_WRITE_UPDATE = "branch.listing.write.update";
  static LISTING_WRITE_UPDATE_OWNED_BY = "branch.listing.write.update.owned-by";
  static LISTING_WRITE_UPDATE_NAME = "branch.listing.write.update.branch-name";
  static LISTING_WRITE_UPDATE_DESCRIPTION =
    "branch.listing.write.update.description";
  static LISTING_WRITE_UPDATE_ADDRESS = "branch.listing.write.update.address";
  static LISTING_WRITE_UPDATE_CONTACT = "branch.listing.write.update.contact";
  static LISTING_WRITE_UPDATE_EMAIL = "branch.listing.write.update.email";
  static LISTING_WRITE_UPDATE_TIMEZONE = "branch.listing.write.update.timezone";
  static LISTING_WRITE_UPDATE_SOCIAL_MEDIA =
    "branch.listing.write.update.social-media";
  static LISTING_WRITE_UPDATE_GROUP =
    "branch.listing.write.update.branch-group";
  static LISTING_WRITE_UPDATE_LANDING_PAGE_LANGUAGE =
    "branch.listing.write.update.landing-page-language";
  static LISTING_WRITE_UPDATE_STATUS = "branch.listing.write.update.status";

  static GROUP = "branch.group";
  static GROUP_READ = "branch.group.read";
  static GROUP_WRITE = "branch.group.write";
  static GROUP_WRITE_CREATE = "branch.group.write.create";
  static GROUP_WRITE_UPDATE = "branch.group.write.update";
  static GROUP_WRITE_UPDATE_NAME = "branch.group.write.update.name";
  static GROUP_WRITE_UPDATE_BRANCH = "branch.group.write.update.branch";
  static GROUP_WRITE_UPDATE_STOCK_TRANSFER_RULES_SETTINGS =
    "branch.group.write.update.stock-transfer-rules-settings";
  static GROUP_WRITE_DELETE = "branch.group.write.delete";

  static ROLE = "branch.role";
  static ROLE_READ = "branch.role.read";
  static ROLE_WRITE = "branch.role.write";
  static ROLE_WRITE_CREATE = "branch.role.write.create";
  static ROLE_WRITE_UPDATE = "branch.role.write.update";
  static ROLE_WRITE_UPDATE_NAME = "branch.role.write.update.name";
  static ROLE_WRITE_UPDATE_ACCESS_RIGHTS =
    "branch.role.write.update.access-rights";
  static ROLE_WRITE_DELETE = "branch.role.write.delete";
}

class Campaign {
  static LUCKY_DRAW = "campaign.lucky-draw";
  static LUCKY_DRAW_READ = "campaign.lucky-draw.read";
  static LUCKY_DRAW_WRITE = "campaign.lucky-draw.write";
  static LUCKY_DRAW_WRITE_CREATE = "campaign.lucky-draw.write.create";
  static LUCKY_DRAW_WRITE_UPDATE = "campaign.lucky-draw.write.update";
  static LUCKY_DRAW_WRITE_UPDATE_NAME = "campaign.lucky-draw.write.update.name";
  static LUCKY_DRAW_WRITE_UPDATE_PERIOD =
    "campaign.lucky-draw.write.update.period";
  static LUCKY_DRAW_WRITE_UPDATE_DESCRIPTION =
    "campaign.lucky-draw.write.update.description";
  static LUCKY_DRAW_WRITE_UPDATE_IMAGE =
    "campaign.lucky-draw.write.update.image";
  static LUCKY_DRAW_WRITE_UPDATE_ASSIGN_PRODUCT =
    "campaign.lucky-draw.write.update.assign-product";
  static LUCKY_DRAW_WRITE_UPDATE_TERMS_CONDITIONS =
    "campaign.lucky-draw.write.update.terms-conditions";
  static LUCKY_DRAW_WRITE_UPDATE_PARTICIPANT_REGISTRATION_FORM =
    "campaign.lucky-draw.write.update.participant-registration-form";
  static LUCKY_DRAW_WRITE_UPDATE_STATUS =
    "campaign.lucky-draw.write.update.status";

  static LUCKY_DRAW_WRITE_PRIZE = "campaign.lucky-draw.write.prize";
  static LUCKY_DRAW_WRITE_PRIZE_READ = "campaign.lucky-draw.write.prize.read";
  static LUCKY_DRAW_WRITE_PRIZE_WRITE = "campaign.lucky-draw.write.prize.write";
  static LUCKY_DRAW_WRITE_PRIZE_DELETE =
    "campaign.lucky-draw.write.prize.delete";

  static LUCKY_DRAW_WRITE_WINNER = "campaign.lucky-draw.write.winner";
  static LUCKY_DRAW_WRITE_WINNER_READ = "campaign.lucky-draw.write.winner.read";
  static LUCKY_DRAW_WRITE_WINNER_WRITE =
    "campaign.lucky-draw.write.winner.write";

  static LUCKY_DRAW_WRITE_LIVE_DRAW = "campaign.lucky-draw.write.live-draw";

  static INSTANT_LUCKY_DRAW = "campaign.instant-lucky-draw";
  static INSTANT_LUCKY_DRAW_READ = "campaign.instant-lucky-draw.read";
  static INSTANT_LUCKY_DRAW_WRITE = "campaign.instant-lucky-draw.write";
  static INSTANT_LUCKY_DRAW_WRITE_CREATE =
    "campaign.instant-lucky-draw.write.create";
  static INSTANT_LUCKY_DRAW_WRITE_UPDATE =
    "campaign.instant-lucky-draw.write.update";
  static INSTANT_LUCKY_DRAW_WRITE_UPDATE_NAME =
    "campaign.instant-lucky-draw.write.update.name";
  static INSTANT_LUCKY_DRAW_WRITE_UPDATE_PERIOD =
    "campaign.instant-lucky-draw.write.update.period";
  static INSTANT_LUCKY_DRAW_WRITE_UPDATE_DESCRIPTION =
    "campaign.instant-lucky-draw.write.update.description";
  static INSTANT_LUCKY_DRAW_WRITE_UPDATE_IMAGE =
    "campaign.instant-lucky-draw.write.update.image";
  static INSTANT_LUCKY_DRAW_WRITE_UPDATE_ASSIGN_PRODUCT =
    "campaign.instant-lucky-draw.write.update.products";
  static INSTANT_LUCKY_DRAW_WRITE_UPDATE_TNC =
    "campaign.instant-lucky-draw.write.update.tnc";
  static INSTANT_LUCKY_DRAW_WRITE_UPDATE_GAME_TEMPLATE =
    "campaign.instant-lucky-draw.write.update.game-template";
  static INSTANT_LUCKY_DRAW_WRITE_UPDATE_REGISTRATION_FORM =
    "campaign.instant-lucky-draw.write.update.registration-form";
  static INSTANT_LUCKY_DRAW_WRITE_UPDATE_STATUS =
    "campaign.instant-lucky-draw.write.update.status";

  static INSTANT_LUCKY_DRAW_WRITE_PRIZE =
    "campaign.instant-lucky-draw.write.prize";
  static INSTANT_LUCKY_DRAW_WRITE_PRIZE_READ =
    "campaign.instant-lucky-draw.write.prize.read";
  static INSTANT_LUCKY_DRAW_WRITE_PRIZE_WRITE =
    "campaign.instant-lucky-draw.write.prize.write";
  static INSTANT_LUCKY_DRAW_WRITE_PRIZE_DELETE =
    "campaign.instant-lucky-draw.write.prize.delete";

  static INSTANT_LUCKY_DRAW_WRITE_WINNER =
    "campaign.instant-lucky-draw.write.winner";
  static INSTANT_LUCKY_DRAW_WRITE_WINNER_READ =
    "campaign.instant-lucky-draw.write.winner.read";
  static INSTANT_LUCKY_DRAW_WRITE_WINNER_WRITE =
    "campaign.instant-lucky-draw.write.winner.write";

  static INSTANT_LUCKY_DRAW_WRITE_PUBLISH =
    "campaign.instant-lucky-draw.write.publish";
}

class Survey {
  static MODULE = "survey";
  static LISTING = "survey.listing";
  static LISTING_READ = "survey.listing.read";
  static LISTING_WRITE = "survey.listing.write";
  static LISTING_WRITE_CREATE = "survey.listing.write.create";
  static LISTING_WRITE_UPDATE = "survey.listing.write.update";
  static LISTING_WRITE_UPDATE_NAME = "survey.listing.write.update.name";
  static LISTING_WRITE_UPDATE_DESCRIPTION =
    "survey.listing.write.update.description";
  static LISTING_WRITE_UPDATE_ASSIGN_PRODUCT =
    "survey.listing.write.update.assign-product";
  static LISTING_WRITE_UPDATE_PERIOD = "survey.listing.write.update.period";
  static LISTING_WRITE_UPDATE_QUESTION = "survey.listing.write.update.question";
  static VOUCHER = "survey.voucher";
  static VOUCHER_READ = "survey.voucher.read";
  static VOUCHER_WRITE = "survey.voucher.write";
  static VOUCHER_WRITE_CREATE = "survey.voucher.write.create";
  static VOUCHER_WRITE_UPDATE = "survey.voucher.write.update";
  static VOUCHER_WRITE_DELETE = "survey.voucher.write.delete";
}

class LoyaltyProgram {
  static MODULE = "loyalty-program";

  static LOYALTY_POINT = "loyalty-program.loyalty-point";
  static LOYALTY_POINT_READ = "loyalty-program.loyalty-point.read";
  static LOYALTY_POINT_WRITE = "loyalty-program.loyalty-point.write";
  static LOYALTY_POINT_WRITE_CREATE =
    "loyalty-program.loyalty-point.write.create";
  static LOYALTY_POINT_WRITE_UPDATE =
    "loyalty-program.loyalty-point.write.update";
  static LOYALTY_POINT_WRITE_UPDATE_POINTS =
    "loyalty-program.loyalty-point.write.update.points";
  static LOYALTY_POINT_WRITE_UPDATE_ASSIGN_PRODUCT =
    "loyalty-program.loyalty-point.write.update.assign-product";
  static LOYALTY_POINT_WRITE_UPDATE_STATUS =
    "loyalty-program.loyalty-point.write.update.status";

  static BONANZA = "loyalty-program.bonanza";
  static BONANZA_READ = "loyalty-program.bonanza.read";
  static BONANZA_WRITE = "loyalty-program.bonanza.write";
  static BONANZA_WRITE_CREATE = "loyalty-program.bonanza.write.create";
  static BONANZA_WRITE_UPDATE = "loyalty-program.bonanza.write.update";
  static BONANZA_WRITE_UPDATE_DETAILS =
    "loyalty-program.bonanza.write.update.details";
  static BONANZA_WRITE_UPDATE_PERIOD =
    "loyalty-program.bonanza.write.update.period";
  static BONANZA_WRITE_UPDATE_ASSIGN_MODULE =
    "loyalty-program.bonanza.write.update.assign-module";
  static BONANZA_WRITE_UPDATE_STATUS =
    "loyalty-program.bonanza.write.update.status";

  static GIFT = "loyalty-program.gift";
  static GIFT_READ = "loyalty-program.gift.read";
  static GIFT_WRITE = "loyalty-program.gift.write";
  static GIFT_WRITE_CREATE = "loyalty-program.gift.write.create";
  static GIFT_WRITE_UPDATE = "loyalty-program.gift.write.update";
  static GIFT_WRITE_UPDATE_PHOTO = "loyalty-program.gift.write.update.photo";
  static GIFT_WRITE_UPDATE_NAME = "loyalty-program.gift.write.update.name";
  static GIFT_WRITE_UPDATE_DESCRIPTION =
    "loyalty-program.gift.write.update.description";
  static GIFT_WRITE_UPDATE_PERIOD = "loyalty-program.gift.write.update.period";
  static GIFT_WRITE_UPDATE_PER_CUSTOMER =
    "loyalty-program.gift.write.update.per-customer";
  static GIFT_WRITE_UPDATE_POINTS_REQUIRED =
    "loyalty-program.gift.write.update.points-required";
  static GIFT_WRITE_UPDATE_STOCK_QUANTITY =
    "loyalty-program.gift.write.update.stock-quantity";
  static GIFT_WRITE_UPDATE_STATUS = "loyalty-program.gift.write.update.status";

  static GIFT_REDEMPTION = "loyalty-program.gift-redemption";
  static GIFT_REDEMPTION_READ = "loyalty-program.gift-redemption.read";
  static GIFT_REDEMPTION_WRITE = "loyalty-program.gift-redemption.write";
  static GIFT_REDEMPTION_WRITE_UPDATE =
    "loyalty-program.gift-redemption.write.update";
  static GIFT_REDEMPTION_WRITE_UPDATE_STATUS =
    "loyalty-program.gift-redemption.write.update.status";
  static GIFT_REDEMPTION_WRITE_UPDATE_DELIVERY_UPDATE =
    "loyalty-program.gift-redemption.write.update.delivery-update";

  static POINT_CUT = "loyalty-program.point-cut";
  static POINT_CUT_READ = "loyalty-program.point-cut.read";
  static POINT_CUT_WRITE = "loyalty-program.point-cut.write";
  static POINT_CUT_WRITE_CREATE = "loyalty-program.point-cut.write.create";
  static POINT_CUT_WRITE_UPDATE = "loyalty-program.point-cut.write.update";
  static POINT_CUT_WRITE_UPDATE_DETAILS =
    "loyalty-program.point-cut.write.update.details";
  static POINT_CUT_WRITE_UPDATE_PERIOD =
    "loyalty-program.point-cut.write.update.period";
  static POINT_CUT_WRITE_UPDATE_GIFT =
    "loyalty-program.point-cut.write.update.gift";
  static POINT_CUT_WRITE_UPDATE_STATUS =
    "loyalty-program.point-cut.write.update.status";
}

class CampaignV2 {
  static MODULE = "campaign-v2";

  static LUCKY_DRAW_LIST = "campaign-v2.lucky-draw";
  static LUCKY_DRAW_LIST_READ = "campaign-v2.lucky-draw.read";

  static LUCKY_DRAW_LIST_WRITE = "campaign-v2.lucky-draw.write";
  static LUCKY_DRAW_LIST_WRITE_CREATE_TRADITIONAL_RAFFLE =
    "campaign-v2.lucky-draw.write.create-traditional-raffle";
  static LUCKY_DRAW_LIST_WRITE_CREATE_INSTANT_WIN =
    "campaign-v2.lucky-draw.write.create-instant-win";
  static LUCKY_DRAW_LIST_WRITE_DUPLICATE =
    "campaign-v2.lucky-draw.write.duplicate";

  static LUCKY_DRAW_LIST_WRITE_UPDATE_TRADITIONAL_RAFFLE =
    "campaign-v2.lucky-draw.write.update-traditional-raffle";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_TRADITIONAL_RAFFLE_BASIC =
    "campaign-v2.lucky-draw.write.update-traditional-raffle.basic";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_TRADITIONAL_RAFFLE_PERIOD =
    "campaign-v2.lucky-draw.write.update-traditional-raffle.period";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_TRADITIONAL_RAFFLE_PRIZE =
    "campaign-v2.lucky-draw.write.update-traditional-raffle.prize";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_TRADITIONAL_RAFFLE_PARTICIPANT =
    "campaign-v2.lucky-draw.write.update-traditional-raffle.participant";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_TRADITIONAL_RAFFLE_PRODUCTS =
    "campaign-v2.lucky-draw.write.update-traditional-raffle.products";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_TRADITIONAL_RAFFLE_WINNER =
    "campaign-v2.lucky-draw.write.update-traditional-raffle.winner";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_TRADITIONAL_RAFFLE_STATUS =
    "campaign-v2.lucky-draw.write.update-traditional-raffle.status";

  static LUCKY_DRAW_LIST_WRITE_UPDATE_INSTANT_WIN =
    "campaign-v2.lucky-draw.write.update-instant-win";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_INSTANT_WIN_BASIC =
    "campaign-v2.lucky-draw.write.update-instant-win.basic";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_INSTANT_WIN_PERIOD =
    "campaign-v2.lucky-draw.write.update-instant-win.period";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_INSTANT_WIN_PRIZE =
    "campaign-v2.lucky-draw.write.update-instant-win.prize";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_INSTANT_WIN_WIN_RATE =
    "campaign-v2.lucky-draw.write.update-instant-win.win-rate";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_INSTANT_WIN_PARTICIPANT =
    "campaign-v2.lucky-draw.write.update-instant-win.participant";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_INSTANT_WIN_PRODUCTS =
    "campaign-v2.lucky-draw.write.update-instant-win.products";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_INSTANT_WIN_WINNER =
    "campaign-v2.lucky-draw.write.update-instant-win.winner";
  static LUCKY_DRAW_LIST_WRITE_UPDATE_INSTANT_WIN_STATUS =
    "campaign-v2.lucky-draw.write.update-instant-win.status";

  static LUCKY_DRAW_LIST_WRITE_DELETE_TRADITIONAL_RAFFLE =
    "campaign-v2.lucky-draw.write.delete-traditional-raffle";
  static LUCKY_DRAW_LIST_WRITE_DELETE_INSTANT_WIN =
    "campaign-v2.lucky-draw.write.delete-instant-win";

  static LOYALTY_POINT_DISTRIBUTION_REPORT =
    "campaign-v2.loyalty-point-distribution-report";
  static CAMPAIGN_REPORTING = "campaign-v2.campaign-reporting";
  static WELCOME_REWARD_SUMMARY = "campaign-v2.welcome-reward-summary";

  static WELCOME_REWARD_SETTING = "campaign-v2.welcome-reward-setting";
  static WELCOME_REWARD_SETTING_READ =
    "campaign-v2.welcome-reward-setting.read";
  static WELCOME_REWARD_SETTING_WRITE =
    "campaign-v2.welcome-reward-setting.write";

  static LOYALTY_POINT_REPORT = "campaign-v2.loyalty-point-report";
  static LOYALTY_POINT_REPORT_READ = "campaign-v2.loyalty-point-report.read";
  static LOYALTY_POINT_REPORT_WRITE = "campaign-v2.loyalty-point-report.write";
}

class Company {
  static MODULE = "company";

  static INFO = "company.info";
  static INFO_READ = "company.info.read";
  static INFO_WRITE = "company.info.write";
  static INFO_WRITE_INDUSTRY = "company.info.write.industry";
  static INFO_WRITE_CONTACT = "company.info.write.contact";
  static INFO_WRITE_ADDRESS = "company.info.write.address";
  static INFO_WRITE_LOGO = "company.info.write.company-logo";

  static PRODUCT_PAGE = "company.product-page";
  static PRODUCT_PAGE_READ = "company.product-page.read";
  static PRODUCT_PAGE_WRITE = "company.product-page.write";
  static PRODUCT_PAGE_WRITE_LANDING_PAGE_UI =
    "company.product-page.write.landing-page-ui";
  static PRODUCT_PAGE_WRITE_GENERAL = "company.product-page.write.general";
  static PRODUCT_PAGE_WRITE_CONTACT =
    "company.product-page.write.company-contact";
  static PRODUCT_PAGE_WRITE_LANGUAGE = "company.product-page.write.language";
  static PRODUCT_PAGE_WRITE_SOCIAL_MEDIA =
    "company.product-page.write.company-social-media";
  static PRODUCT_PAGE_WRITE_PRIVACY_POLICY =
    "company.product-page.write.privacy-policy";

  static DEFAULT_PROFILE = "company.default-profile";

  static CURRENCY = "company.currency";
  static CURRENCY_READ = "company.currency.read";
  static CURRENCY_WRITE = "company.currency.write";
  static CURRENCY_WRITE_ADD = "company.currency.write.add";
  static CURRENCY_WRITE_UPDATE = "company.currency.write.update";
  static CURRENCY_WRITE_UPDATE_CURRENCY_STATUS =
    "company.currency.write.update.currency-status";
  static CURRENCY_WRITE_DELETE = "company.currency.write.delete";

  static STOCK_MODULE = "company.stock-module";
  static STOCK_MODULE_READ = "company.stock-module.read";
  static STOCK_MODULE_WRITE = "company.stock-module.write";
  static STOCK_MODULE_WRITE_EMAIL_SETTINGS =
    "company.stock-module.write.email-settings";
  static STOCK_MODULE_WRITE_DEALER_STOCKFLOW =
    "company.stock-module.write.dealer-stockflow";
  static STOCK_MODULE_WRITE_DEALER_INCENTIVE_POINTS =
    "company.stock-module.write.dealer-incentive-points";
  static STOCK_MODULE_WRITE_BRANCH_STOCKFLOW =
    "company.stock-module.write.branch-stockflow";

  static INTEGRATION = "company.integration";
  static INTEGRATION_READ = "company.integration.read";
  static INTEGRATION_WRITE = "company.integration.write";
  static INTEGRATION_WRITE_API_ENDPOINT_SETTING =
    "company.integration.write.api-endpoint-setting";
  static INTEGRATION_WRITE_API_AUTHORIZATION =
    "company.integration.write.api-authorization";
  static INTEGRATION_WRITE_SETTINGS =
    "company.integration.write.company-settings";
  static INTEGRATION_WRITE_MATERIAL_DOCUMENT_API =
    "company.integration.write.material-document-api";
  static INTEGRATION_WRITE_PRODUCT_DETAILS_API =
    "company.integration.write.product-details-api";
  static INTEGRATION_WRITE_CUSTOMER_SALES_DATA_API =
    "company.integration.write.customer-sales-data-api";

  static CONSUMER_ENGAGEMENT = "company.consumer-engagement";
  static CONSUMER_ENGAGEMENT_READ = "company.consumer-engagement.read";
  static CONSUMER_ENGAGEMENT_WRITE = "company.consumer-engagement.write";
  static CONSUMER_ENGAGEMENT_WRITE_UPDATE =
    "company.consumer-engagement.write.update";
  static CONSUMER_ENGAGEMENT_WRITE_UPDATE_CREDIT_ALERTS =
    "company.consumer-engagement.write.update.credit-alerts";

  static SMTP = "company.smtp";
}

class Consumer {
  static MODULE = "consumer";

  static LIST = "consumer.consumer";
  static LIST_READ = "consumer.consumer.read";

  static LIST_WRITE = "consumer.consumer.write";
  static LIST_WRITE_LOYALTY_POINT = "consumer.consumer.write.loyalty-point";
  static LIST_WRITE_LOYALTY_POINT_UPDATE =
    "consumer.consumer.write.loyalty-point.update";
  static LIST_WRITE_LOYALTY_POINT_UPDATE_REMARK =
    "consumer.consumer.write.loyalty-point.update-remark";
}

class Counterfeit {
  static MODULE = "counterfeit";

  static LIST = "counterfeit.listing";
  static LIST_READ = "counterfeit.listing.read";

  static LIST_WRITE = "counterfeit.listing.write";
  static LIST_WRITE_UPDATE = "counterfeit.listing.write.update";
  static LIST_WRITE_UPDATE_ADMIN_REMARK =
    "counterfeit.listing.write.update.admin-remark";
}

class Dashboard {
  static MODULE = "dashboard";
}

class DkshCustom {
  static MODULE = "dksh";
  static PRODUCT_LIST = "dksh.product";
  static PRODUCT_LIST_READ = "dksh.product.read";
  static PRODUCT_LIST_WRITE = "dksh.product.write";

  static INVOICE = "dksh.invoice";

  static TRACKCO_INVOICE = "dksh.trackco-invoice";
  static TRACKCO_INVOICE_READ = "dksh.trackco-invoice.read";
  static TRACKCO_INVOICE_WRITE = "dksh.trackco-invoice.write";
  static TRACKCO_INVOICE_WRITE_UPDATE = "dksh.trackco-invoice.write.update";
}

class Employee {
  static MODULE = "employee";
  static READ = "employee.read";
  static WRITE = "employee.write";
  static WRITE_CREATE = "employee.write.create";
  static WRITE_UPDATE = "employee.write.update";
  static WRITE_UPDATE_ROLE = "employee.write.update.role";
  static WRITE_UPDATE_BRANCH = "employee.write.update.branch";
  static WRITE_UPDATE_STATUS = "employee.write.update.status";
  static WRITE_DELETE = "employee.write.delete";
}

class ExternalApi {
  static SUBMODULE = "external";
}

class Marketplace {
  static MODULE = "marketplace";

  static VIEW = "marketplace.read";

  static WRITE = "marketplace.write";
  static WRITE_PURCHASE_QR_CODE_CREDIT =
    "marketplace.write.qr-code-credit-purchase";
  static WRITE_PURCHASE_SMS_CREDIT = "marketplace.write.sms-credit-purchase";
  static WRITE_PURCHASE_SUBSCRIPTION_PLANS_SWAP =
    "marketplace.write.subscription-plans-swap";
}

class OrganisationStructure {
  static MODULE = "organisation-structure";
}

class PhilipsCustom {
  static MODULE = "philips";
  static DELIVERY_NOTE = "philips.delivery-note";
  static DELIVERY_NOTE_READ = "philips.delivery-note.read";
  static DELIVERY_NOTE_WRITE = "philips.delivery-note.write";
}

class PrifeCustom {
  static MODULE = "prife";

  static MASTER_LIST = "prife.master-list";
  static MASTER_LIST_READ = "prife.master-list.read";
  static MASTER_LIST_WRITE = "prife.master-list.write";
  static MASTER_LIST_WRITE_HQ_PIC = "prife.master-list.write.hq-pic";
  static MASTER_LIST_WRITE_HQ_APPROVAL = "prife.master-list.write.hq-approval";
  static MASTER_LIST_WRITE_SUBMIT_TO_FINANCE =
    "prife.master-list.write.submit-to-finance";
  static MASTER_LIST_WRITE_FINANCE_APPROVAL =
    "prife.master-list.write.finance-approval";
  static MASTER_LIST_WRITE_CREATE_PURCHASE_ORDER =
    "prife.master-list.write.create-purchase-order";

  static SHIPPING_ORDER = "prife.shipping-order";
  static SHIPPING_ORDER_READ = "prife.shipping-order.read";
  static SHIPPING_ORDER_WRITE = "prife.shipping-order.write";

  static DISPATCH_INSTRUCTION = "prife.dispatch-instruction";
  static DISPATCH_INSTRUCTION_READ = "prife.dispatch-instruction.read";
  static DISPATCH_INSTRUCTION_WRITE = "prife.dispatch-instruction.write";
  static DISPATCH_INSTRUCTION_WRITE_UPDATE =
    "prife.dispatch-instruction.write.update";
  static DISPATCH_INSTRUCTION_WRITE_APPROVAL =
    "prife.dispatch-instruction.write.approval";

  static RECEIVE_TRANSFER = "prife.receive-transfer";
  static RECEIVE_TRANSFER_READ = "prife.receive-transfer.read";
  static RECEIVE_TRANSFER_WRITE = "prife.receive-transfer.write";

  static DELIVERY_INFO = "prife.delivery-info";

  static PURCHASE_ORDER = "prife.purchase-order";
  static PURCHASE_ORDER_READ = "prife.purchase-order.read";
  static PURCHASE_ORDER_WRITE = "prife.purchase-order.write";
  static PURCHASE_ORDER_WRITE_CREATE = "prife.purchase-order.write.create";
  static PURCHASE_ORDER_WRITE_UPDATE = "prife.purchase-order.write.update";
  static PURCHASE_ORDER_WRITE_NOTIFICATION =
    "prife.purchase-order.write.notification";

  static CHECKOUT = "prife.checkout";
  static CHECKOUT_READ = "prife.checkout.read";
  static CHECKOUT_WRITE = "prife.checkout.write";

  static WARRANTY_CLAIM = "prife.warranty-claim";
  static WARRANTY_CLAIM_READ = "prife.warranty-claim.read";
  static WARRANTY_CLAIM_WRITE = "prife.warranty-claim.write";
  static WARRANTY_CLAIM_WRITE_WIDE_ACCESS =
    "prife.warranty-claim.write.wide-access";

  static WARRANTY_REPLACEMENT = "prife.warranty-replacement";
  static WARRANTY_REPLACEMENT_READ = "prife.warranty-replacement.read";
  static WARRANTY_REPLACEMENT_WRITE = "prife.warranty-replacement.write";
  static WARRANTY_REPLACEMENT_WRITE_REPLACEMENT_WIDE_ACCESS =
    "prife.warranty-replacement.write.replacement-wide-access";
  static WARRANTY_REPLACEMENT_WRITE_REIMBURSEMENT_WIDE_ACCESS =
    "prife.warranty-replacement.write.reimbursement-wide-access";
}

class Product {
  static MODULE = "product";

  static LISTING = "product.listing";
  static LISTING_READ = "product.listing.read";
  static LISTING_WRITE = "product.listing.write";
  static LISTING_CREATE = "product.listing.write.create";
  static LISTING_UPDATE = "product.listing.write.update";
  static LISTING_UPDATE_BRANCH = "product.listing.write.update.branch";
  static LISTING_UPDATE_NAME = "product.listing.write.update.name";
  static LISTING_UPDATE_CATEGORY = "product.listing.write.update.category";
  static LISTING_UPDATE_BRAND_MODEL =
    "product.listing.write.update.brand-model";
  static LISTING_UPDATE_ATTRIBUTES = "product.listing.write.update.attributes";
  static LISTING_UPDATE_DESCRIPTION =
    "product.listing.write.update.description";
  static LISTING_UPDATE_SKU = "product.listing.write.update.sku";
  static LISTING_UPDATE_SCAN_LIMIT = "product.listing.write.update.scan-limit";
  static LISTING_UPDATE_DEALER_INCENTIVE_POINT =
    "product.listing.write.update.dealer-incentive-point";
  static LISTING_UPDATE_WARRANTY_NAME =
    "product.listing.write.update.warranty-name";
  static LISTING_UPDATE_STATUS = "product.listing.write.update.status";
  static LISTING_DELETE = "product.listing.write.delete";
  static LISTING_ASSIGN = "product.listing.write.assign";
  static LISTING_PUBLISH_UNPUBLISH = "product.listing.write.publish-unpublish";

  static LANDING_PAGE = "product.landing-page";
  static LANDING_PAGE_READ = "product.landing-page.read";
  static LANDING_PAGE_WRITE = "product.landing-page.write";
  static LANDING_PAGE_UPDATE_TEMPLATE = "product.landing-page.write.template";
  static LANDING_PAGE_UPDATE_COMPONENT = "product.landing-page.write.component";
  static LANDING_PAGE_UPDATE_SETTING = "product.landing-page.write.setting";

  static CATEGORY = "product.category";
  static CATEGORY_READ = "product.category.read";
  static CATEGORY_WRITE = "product.category.write";
  static CATEGORY_CREATE = "product.category.write.create";
  static CATEGORY_UPDATE = "product.category.write.update";
  static CATEGORY_UPDATE_NAME = "product.category.write.update.name";
  static CATEGORY_UPDATE_STATUS = "product.category.write.update.status";
  static CATEGORY_DELETE = "product.category.write.delete";

  static BRAND_MODEL = "product.brand-model";
  static BRAND_MODEL_READ = "product.brand-model.read";
  static BRAND_MODEL_WRITE = "product.brand-model.write";
  static BRAND_MODEL_CREATE = "product.brand-model.write.create";
  static BRAND_MODEL_UPDATE = "product.brand-model.write.update";
  static BRAND_MODEL_UPDATE_BRAND_NAME =
    "product.brand-model.write.update.brand-name";
  static BRAND_MODEL_UPDATE_DESCRIPTION =
    "product.brand-model.write.update.description";
  static BRAND_MODEL_UPDATE_MODELS = "product.brand-model.write.update.models";
  static BRAND_MODEL_UPDATE_BRAND_IMAGE =
    "product.brand-model.write.update.brand-image";
  static BRAND_MODEL_UPDATE_STATUS = "product.brand-model.write.update.status";
  static BRAND_MODEL_DELETE = "product.brand-model.write.delete";

  static ATTRIBUTE = "product.attribute";
  static ATTRIBUTE_READ = "product.attribute.read";
  static ATTRIBUTE_WRITE = "product.attribute.write";
  static ATTRIBUTE_CREATE = "product.attribute.write.create";
  static ATTRIBUTE_UPDATE = "product.attribute.write.update";
  static ATTRIBUTE_UPDATE_NAME = "product.attribute.write.update.name";
  static ATTRIBUTE_UPDATE_OPTION = "product.attribute.write.update.option";
  static ATTRIBUTE_UPDATE_STATUS = "product.attribute.write.update.status";
  static ATTRIBUTE_DELETE = "product.attribute.write.delete";

  static LANDING_TEMPLATE = "product.landing-template";
  static LANDING_TEMPLATE_READ = "product.landing-template.read";
  static LANDING_TEMPLATE_WRITE = "product.landing-template.write";
  static LANDING_TEMPLATE_CREATE = "product.landing-template.write.create";
  static LANDING_TEMPLATE_UPDATE = "product.landing-template.write.update";
  static LANDING_TEMPLATE_UPDATE_NAME =
    "product.landing-template.write.update.name";
  static LANDING_TEMPLATE_UPDATE_ASSIGNED_PRODUCTS =
    "product.landing-template.write.update.assigned-products";
  static LANDING_TEMPLATE_UPDATE_COMPONENT =
    "product.landing-template.write.update.component";
  static LANDING_TEMPLATE_UPDATE_SETTING =
    "product.landing-template.write.update.setting";
  static LANDING_TEMPLATE_DELETE = "product.landing-template.write.delete";
}

class Qr {
  static MODULE = "qr";

  static SERIAL_NUMBER = "qr.serial-number";
  static SERIAL_NUMBER_READ = "qr.serial-number.read";
  static SERIAL_NUMBER_WRITE = "qr.serial-number.write";
  static SERIAL_NUMBER_CREATE = "qr.serial-number.write.create";
  static SERIAL_NUMBER_UPDATE = "qr.serial-number.write.update";
  static SERIAL_NUMBER_UPDATE_RESET_SCAN_COUNT =
    "qr.serial-number.write.update.reset-scan-count";
  static SERIAL_NUMBER_SUSPEND_REACTIVATE =
    "qr.serial-number.write.suspend-reactivate";

  static BATCH = "qr.batch";
  static BATCH_READ = "qr.batch.read";
  static BATCH_WRITE = "qr.batch.write";
  static BATCH_UPDATE_APP_AUTHENTICATOR = "qr.batch.write.app-authenticator";
  static BATCH_UPDATE_PRODUCT_PAGE_PREVIEW =
    "qr.batch.write.product-page-preview";

  static TAG = "qr.tag";
  static TAG_READ = "qr.tag.read";
  static TAG_WRITE = "qr.tag.write";

  static ASSIGN = "qr.assign";

  static UNASSIGN = "qr.unassign";
  static UNASSIGN_READ = "qr.unassign.read";
  static UNASSIGN_WRITE = "qr.unassign.write";
  static UNASSIGN_UNASSIGN = "qr.unassign.write.unassign";

  static ADDITIONAL_INFO = "qr.additional-info";
  static ADDITIONAL_INFO_READ = "qr.additional-info.read";
  static ADDITIONAL_INFO_WRITE = "qr.additional-info.write";
  static ADDITIONAL_INFO_CREATE = "qr.additional-info.write.create";
  static ADDITIONAL_INFO_UPDATE = "qr.additional-info.write.update";
  static ADDITIONAL_INFO_UPDATE_TITLE = "qr.additional-info.write.update.title";
  static ADDITIONAL_INFO_UPDATE_DESCRIPTION =
    "qr.additional-info.write.update.description";
  static ADDITIONAL_INFO_DELETE = "qr.additional-info.write.delete";
}

class Reporting {
  static MODULE = "reporting";
}

class StockOverview {
  static MODULE = "stock-overview";
}

class TrackcoMobile {
  static MODULE = "trackco-mobile";

  static PRODUCT_LIST = "trackco-mobile.product-list";
  static PRODUCT_LIST_READ = "trackco-mobile.product-list.read";

  static PACKAGE_LIST = "trackco-mobile.package-list";
  static PACKAGE_LIST_READ = "trackco-mobile.package-list.read";
  static PACKAGE_LIST_WRITE = "trackco-mobile.package-list.write";
  static PACKAGE_LIST_WRITE_PACKING =
    "trackco-mobile.package-list.write.packing";
  static PACKAGE_LIST_WRITE_DELETE = "trackco-mobile.package-list.write.delete";

  static BOX_LIST = "trackco-mobile.box-list";
  static BOX_LIST_READ = "trackco-mobile.box-list.read";
  static BOX_LIST_WRITE = "trackco-mobile.box-list.write";
  static BOX_LIST_WRITE_BOXING = "trackco-mobile.box-list.write.boxing";
  static BOX_LIST_WRITE_DELETE = "trackco-mobile.box-list.write.delete";

  static ORDERS = "trackco-mobile.orders";
  static ORDERS_READ = "trackco-mobile.orders.read";
  static ORDERS_WRITE = "trackco-mobile.orders.write";

  static STOCK_OUT = "trackco-mobile.stock-out";
  static STOCK_OUT_READ = "trackco-mobile.stock-out.read";
  static STOCK_OUT_WRITE = "trackco-mobile.stock-out.write";
  static STOCK_OUT_WRITE_ADD = "trackco-mobile.stock-out.write.add";
  static STOCK_OUT_WRITE_CANCEL = "trackco-mobile.stock-out.write.cancel";

  static RECALL = "trackco-mobile.recall";
  static RECALL_READ = "trackco-mobile.recall.read";
  static RECALL_WRITE = "trackco-mobile.recall.write";

  static REQUEST_TRANSFER = "trackco-mobile.request-transfer";
  static REQUEST_TRANSFER_READ = "trackco-mobile.request-transfer.read";
  static REQUEST_TRANSFER_WRITE = "trackco-mobile.request-transfer.write";
  static REQUEST_TRANSFER_WRITE_ADD =
    "trackco-mobile.request-transfer.write.add";
  static REQUEST_TRANSFER_WRITE_CANCEL =
    "trackco-mobile.request-transfer.write.cancel";
  static REQUEST_TRANSFER_WRITE_PROCESS =
    "trackco-mobile.request-transfer.write.process";

  static TRANSFER = "trackco-mobile.transfer";
  static TRANSFER_READ = "trackco-mobile.transfer.read";
  static TRANSFER_WRITE = "trackco-mobile.transfer.write";

  static RECEIVE_TRANSFER = "trackco-mobile.receive-transfer";
  static RECEIVE_TRANSFER_READ = "trackco-mobile.receive-transfer.read";
  static RECEIVE_TRANSFER_WRITE = "trackco-mobile.receive-transfer.write";
  static RECEIVE_TRANSFER_WRITE_REQUEST =
    "trackco-mobile.receive-transfer.write.request";
  static RECEIVE_TRANSFER_WRITE_SCAN =
    "trackco-mobile.receive-transfer.write.scan";

  static STOCKTAKE = "trackco-mobile.stocktake";
  static STOCKTAKE_READ = "trackco-mobile.stocktake.read";
  static STOCKTAKE_WRITE = "trackco-mobile.stocktake.write";

  static CHECKOUT = "trackco-mobile.checkout";
  static CHECKOUT_READ = "trackco-mobile.checkout.read";
  static CHECKOUT_WRITE = "trackco-mobile.checkout.write";
  static CHECKOUT_WRITE_CREATE = "trackco-mobile.checkout.write.create";
  static CHECKOUT_WRITE_CREATE_CONSUMER =
    "trackco-mobile.checkout.write.create-consumer";
  static CHECKOUT_WRITE_UPDATE_CONSUMER =
    "trackco-mobile.checkout.write.update-consumer";
  static CHECKOUT_WRITE_UPDATE_CONSUMER_FULL_NAME =
    "trackco-mobile.checkout.write.update-consumer.full-name";
  static CHECKOUT_WRITE_UPDATE_CONSUMER_MOBILE_NUMBER =
    "trackco-mobile.checkout.write.update-consumer.mobile-number";
  static CHECKOUT_WRITE_UPDATE_CONSUMER_EMAIL =
    "trackco-mobile.checkout.write.update-consumer.email";
  static CHECKOUT_WRITE_UPDATE_CONSUMER_DOB =
    "trackco-mobile.checkout.write.update-consumer.dob";
  static CHECKOUT_WRITE_UPDATE_CONSUMER_GENDER =
    "trackco-mobile.checkout.write.update-consumer.gender";
  static CHECKOUT_WRITE_UPDATE_CONSUMER_ADDRESS =
    "trackco-mobile.checkout.write.update-consumer.address";

  static ASSIGN_SERIAL_NUMBER = "trackco-mobile.assign-serial-number";
  static ASSIGN_SERIAL_NUMBER_READ = "trackco-mobile.assign-serial-number.read";
  static ASSIGN_SERIAL_NUMBER_WRITE =
    "trackco-mobile.assign-serial-number.write";

  static UNASSIGN_SERIAL_NUMBER = "trackco-mobile.unassign-serial-number";
  static UNASSIGN_SERIAL_NUMBER_READ =
    "trackco-mobile.unassign-serial-number.read";
  static UNASSIGN_SERIAL_NUMBER_WRITE =
    "trackco-mobile.unassign-serial-number.write";

  static WARRANTY_REPLACEMENT = "trackco-mobile.warranty-replacement";
  static WARRANTY_REPLACEMENT_READ = "trackco-mobile.warranty-replacement.read";
  static WARRANTY_REPLACEMENT_WRITE =
    "trackco-mobile.warranty-replacement.write";
  static WARRANTY_REPLACEMENT_WRITE_REPLACE =
    "trackco-mobile.warranty-replacement.write.replace";
  static WARRANTY_REPLACEMENT_WRITE_HANDOFF =
    "trackco-mobile.warranty-replacement.write.handoff";

  static PACKAGE_TRACEABILITY = "trackco-mobile.package-traceability";

  static DEALERS = "trackco-mobile.dealers";

  static BUSINESS_INSIGHTS = "trackco-mobile.business-insights";
}

class TrackcoPortal {
  static MODULE = "trackco-portal";

  static BRANCH_INVENTORY = "trackco-portal.branch-inventory";
  static DEALER_INVENTORY = "trackco-portal.dealer-inventory";
  static BRANCH_SUMMARY = "trackco-portal.branch-summary";
  static DEALER_SUMMARY = "trackco-portal.dealer-summary";
  static PACKAGE = "trackco-portal.package";
  static BOXES = "trackco-portal.boxes";
  static LOOSE_ITEM = "trackco-portal.loose-item";

  static CHECKOUT = "trackco-portal.checkout";
  static CHECKOUT_READ = "trackco-portal.checkout.read";
  static CHECKOUT_WRITE = "trackco-portal.checkout.write";
  static CHECKOUT_UPDATE = "trackco-portal.checkout.write.update";
  static CHECKOUT_UPDATE_DELIVERY_INFO =
    "trackco-portal.checkout.write.update.delivery-info";
  static CHECKOUT_UPDATE_REMARK = "trackco-portal.checkout.write.update.remark";

  static DEALER = "trackco-portal.dealer";
  static DEALER_READ = "trackco-portal.dealer.read";
  static DEALER_WRITE = "trackco-portal.dealer.write";
  static DEALER_CREATE = "trackco-portal.dealer.write.create";
  static DEALER_UPDATE = "trackco-portal.dealer.write.update";
  static DEALER_UPDATE_NAME = "trackco-portal.dealer.write.update.name";
  static DEALER_UPDATE_STATUS = "trackco-portal.dealer.write.update.status";
  static DEALER_UPDATE_INCENTIVE_POINT =
    "trackco-portal.dealer.write.update-incentive-point";
  static DEALER_UPDATE_INCENTIVE_POINT_ADJUSTMENT =
    "trackco-portal.dealer.write.update-incentive-point.adjustment";
  static DEALER_UPDATE_INCENTIVE_POINT_REMARK =
    "trackco-portal.dealer.write.update-incentive-point.remark";

  static DEALER_INCENTIVE_PROGRAM = "trackco-portal.dealer-incentive-program";
  static DEALER_INCENTIVE_PROGRAM_READ =
    "trackco-portal.dealer-incentive-program.read";
  static DEALER_INCENTIVE_PROGRAM_WRITE =
    "trackco-portal.dealer-incentive-program.write";
  static DEALER_INCENTIVE_PROGRAM_CREATE =
    "trackco-portal.dealer-incentive-program.write.create";
  static DEALER_INCENTIVE_PROGRAM_UPDATE =
    "trackco-portal.dealer-incentive-program.write.update";
  static DEALER_INCENTIVE_PROGRAM_UPDATE_NAME =
    "trackco-portal.dealer-incentive-program.write.update.program-name";
  static DEALER_INCENTIVE_PROGRAM_UPDATE_ASSIGNED_PRODUCT =
    "trackco-portal.dealer-incentive-program.write.update.assigned-product";
  static DEALER_INCENTIVE_PROGRAM_UPDATE_DISTRIBUTE_POINTS =
    "trackco-portal.dealer-incentive-program.write.update.distribute-dealers-incentive-points";
  static DEALER_INCENTIVE_PROGRAM_UPDATE_STATUS =
    "trackco-portal.dealer-incentive-program.write.update.status";
  static DEALER_INCENTIVE_PROGRAM_DELETE =
    "trackco-portal.dealer-incentive-program.write.delete";

  static REWARD = "trackco-portal.reward";
  static REWARD_READ = "trackco-portal.reward.read";
  static REWARD_WRITE = "trackco-portal.reward.write";
  static REWARD_CREATE = "trackco-portal.reward.write.create";
  static REWARD_UPDATE = "trackco-portal.reward.write.update";
  static REWARD_UPDATE_THUMBNAIL =
    "trackco-portal.reward.write.update.thumbnail-photo";
  static REWARD_UPDATE_NAME = "trackco-portal.reward.write.update.name";
  static REWARD_UPDATE_BRANCH = "trackco-portal.reward.write.update.branch";
  static REWARD_UPDATE_POINTS = "trackco-portal.reward.write.update.points";
  static REWARD_UPDATE_DISPLAY_DATE =
    "trackco-portal.reward.write.update.display-date";
  static REWARD_UPDATE_VALIDITY_DATE =
    "trackco-portal.reward.write.update.validity-date";
  static REWARD_UPDATE_STOCK =
    "trackco-portal.reward.write.update.stock-quantity";
  static REWARD_UPDATE_REDEMPTION_LIMIT =
    "trackco-portal.reward.write.update.redemption-limit";
  static REWARD_UPDATE_DESCRIPTION =
    "trackco-portal.reward.write.update.description";
  static REWARD_UPDATE_TERMS =
    "trackco-portal.reward.write.update.terms-conditions";
  static REWARD_UPDATE_STATUS = "trackco-portal.reward.write.update.status";
  static REWARD_DELETE = "trackco-portal.reward.write.delete";

  static ORDER = "trackco-portal.order";
  static ORDER_READ = "trackco-portal.order.read";
  static ORDER_WRITE = "trackco-portal.order.write";
  static ORDER_UPDATE = "trackco-portal.order.write.update";

  static STOCKOUT = "trackco-portal.stockout";
  static STOCKOUT_READ = "trackco-portal.stockout.read";
  static STOCKOUT_WRITE = "trackco-portal.stockout.write";
  static STOCKOUT_UPDATE = "trackco-portal.stockout.write.update";
  static STOCKOUT_UPDATE_STATUS = "trackco-portal.stockout.write.update.status";

  static RECALL = "trackco-portal.recall";
  static RECALL_READ = "trackco-portal.recall.read";
  static RECALL_WRITE = "trackco-portal.recall.write";
  static RECALL_UPDATE = "trackco-portal.recall.write.update";

  static REQUEST_TRANSFER = "trackco-portal.request-transfer";
  static REQUEST_TRANSFER_READ = "trackco-portal.request-transfer.read";
  static REQUEST_TRANSFER_WRITE = "trackco-portal.request-transfer.write";
  static REQUEST_TRANSFER_CREATE =
    "trackco-portal.request-transfer.write.create";
  static REQUEST_TRANSFER_UPDATE =
    "trackco-portal.request-transfer.write.update";
  static REQUEST_TRANSFER_UPDATE_STATUS =
    "trackco-portal.request-transfer.write.update.status";

  static TRANSFER = "trackco-portal.transfer";
  static TRANSFER_READ = "trackco-portal.transfer.read";
  static TRANSFER_WRITE = "trackco-portal.transfer.write";
  static TRANSFER_UPDATE = "trackco-portal.transfer.write.update";
  static TRANSFER_UPDATE_DELIVERY_INFO =
    "trackco-portal.transfer.write.update.delivery-info";
  static TRANSFER_UPDATE_STATUS = "trackco-portal.transfer.write.update.status";

  static RECEIVE_TRANSFER = "trackco-portal.receive-transfer";
  static RECEIVE_TRANSFER_READ = "trackco-portal.receive-transfer.read";
  static RECEIVE_TRANSFER_WRITE = "trackco-portal.receive-transfer.write";
  static RECEIVE_TRANSFER_UPDATE =
    "trackco-portal.receive-transfer.write.update";

  static STOCKTAKE = "trackco-portal.stocktake";
  static STOCKTAKE_READ = "trackco-portal.stocktake.read";
  static STOCKTAKE_WRITE = "trackco-portal.stocktake.write";
  static STOCKTAKE_CREATE = "trackco-portal.stocktake.write.create";
  static STOCKTAKE_UPDATE = "trackco-portal.stocktake.write.update";
  static STOCKTAKE_UPDATE_PROGRAM_NAME =
    "trackco-portal.stocktake.write.update.program-name";
  static STOCKTAKE_UPDATE_STATUS =
    "trackco-portal.stocktake.write.update.status";

  static DAILY_STOCKOUT_SUMMARY = "trackco-portal.daily-stockout-summary";
  static DAILY_STOCKOUT_PRODUCT_SUMMARY =
    "trackco-portal.daily-stockout-product-summary";
}

class Warranty {
  static MODULE = "warranty";

  static LIST = "warranty.listing";
  static LIST_READ = "warranty.listing.read";
  static LIST_WRITE = "warranty.listing.write";
  static LIST_WRITE_UPDATE = "warranty.listing.write.update";
  static LIST_WRITE_UPDATE_NAME = "warranty.listing.write.update.name";
  static LIST_WRITE_UPDATE_PERIOD = "warranty.listing.write.update.period";
  static LIST_WRITE_UPDATE_REQUIRE_APPROVAL =
    "warranty.listing.write.update.require-approval";
  static LIST_WRITE_UPDATE_PRE_REGISTER =
    "warranty.listing.write.update.pre-register";
  static LIST_WRITE_UPDATE_VALIDATE_DO_NUMBER =
    "warranty.listing.write.update.validate-do-number";
  static LIST_WRITE_UPDATE_ENABLE_ITEM_REPLACEMENT =
    "warranty.listing.write.update.enable-item-replacement";
  static LIST_WRITE_UPDATE_ASSIGN_PRODUCT =
    "warranty.listing.write.update.assign-product";
  static LIST_WRITE_UPDATE_TNC = "warranty.listing.write.update.tnc";
  static LIST_WRITE_UPDATE_REASON_OPTION =
    "warranty.listing.write.update.reason-option";
  static LIST_WRITE_UPDATE_EMAIL_NOTIFICATION =
    "warranty.listing.write.update.email-notification";
  static LIST_WRITE_UPDATE_REGISTRATION_FORM =
    "warranty.listing.write.update-registration-form";
  static LIST_WRITE_UPDATE_REGISTRATION_FORM_FIELD_NAME =
    "warranty.listing.write.update-registration-form.field-name";
  static LIST_WRITE_UPDATE_REGISTRATION_FORM_MANDATORY =
    "warranty.listing.write.update-registration-form.mandatory";
  static LIST_WRITE_UPDATE_REGISTRATION_FORM_VISIBLE =
    "warranty.listing.write.update-registration-form.visible";
  static LIST_WRITE_CREATE = "warranty.listing.write.create";
  static LIST_WRITE_CREATE_EXTENSION =
    "warranty.listing.write.create-extension";
  static LIST_WRITE_UPDATE_EXTENSION =
    "warranty.listing.write.update-extension";
  static LIST_WRITE_UPDATE_EXTENSION_PERIOD =
    "warranty.listing.write.update-extension.period";
  static LIST_WRITE_UPDATE_EXTENSION_EFFECTIVE_PERIOD =
    "warranty.listing.write.update-extension.effective-period";
  static LIST_WRITE_GENERATE_CODE = "warranty.listing.write.generate-code";
  static LIST_WRITE_PRE_REGISTER = "warranty.listing.write.pre-register";
  static LIST_WRITE_VALIDATE_DO_NUMBER =
    "warranty.listing.write.validate-do-number";

  static WARRANTEE_LIST = "warranty.warrantee";
  static WARRANTEE_LIST_READ = "warranty.warrantee.read";
  static WARRANTEE_LIST_WRITE = "warranty.warrantee.write";
  static WARRANTEE_LIST_WRITE_UPDATE = "warranty.warrantee.write.update";
  static WARRANTEE_LIST_WRITE_UPDATE_STATUS =
    "warranty.warrantee.write.update.status";
  static WARRANTEE_LIST_WRITE_UPDATE_REGISTRATION_STATUS =
    "warranty.warrantee.write.update.registration-status";

  static CONSUMER_CLAIM_LIST = "warranty.claim";
  static CONSUMER_CLAIM_LIST_READ = "warranty.claim.read";
  static CONSUMER_CLAIM_LIST_WRITE = "warranty.claim.write";
  static CONSUMER_CLAIM_LIST_WRITE_UPDATE = "warranty.claim.write.update";
  static CONSUMER_CLAIM_LIST_WRITE_UPDATE_REMARK =
    "warranty.claim.write.update.remark";
  static CONSUMER_CLAIM_LIST_WRITE_UPDATE_CONTACT_NUMBER =
    "warranty.claim.write.update.contact-number";
  static CONSUMER_CLAIM_LIST_WRITE_UPDATE_DATE_OF_PURCHASE =
    "warranty.claim.write.update.date-of-purchase";
  static CONSUMER_CLAIM_LIST_WRITE_UPDATE_COVERAGE_PERIOD =
    "warranty.claim.write.update.coverage-period";
  static CONSUMER_CLAIM_LIST_WRITE_UPDATE_STATUS =
    "warranty.claim.write.update.status";
  static CONSUMER_CLAIM_LIST_WRITE_REIMBURSEMENT =
    "warranty.claim.write-reimbursement";
  static CONSUMER_CLAIM_LIST_WRITE_REIMBURSEMENT_CREATE =
    "warranty.claim.write-reimbursement.create";
  static CONSUMER_CLAIM_LIST_WRITE_REIMBURSEMENT_UPDATE_STATUS =
    "warranty.claim.write-reimbursement.update-status";
  static CONSUMER_CLAIM_LIST_WRITE_CLAIM_APPROVE_COMPANY =
    "warranty.claim.claim-approve-company";

  static ITEM_REPLACEMENT_HANDOFF_LIST = "warranty.replacement-handoff";
  static ITEM_REPLACEMENT_HANDOFF_LIST_READ =
    "warranty.replacement-handoff.read";
  static ITEM_REPLACEMENT_HANDOFF_LIST_WRITE =
    "warranty.replacement-handoff.write";
  static ITEM_REPLACEMENT_HANDOFF_LIST_WRITE_UPDATE =
    "warranty.replacement-handoff.write.update";
  static ITEM_REPLACEMENT_HANDOFF_LIST_WRITE_UPDATE_HANOFF =
    "warranty.replacement-handoff.write.update.handoff";
  static ITEM_REPLACEMENT_HANDOFF_LIST_WRITE_UPDATE_REPLACE =
    "warranty.replacement-handoff.write.update.replace";

  static REIMBURSEMENT_LIST = "warranty.reimbursement";
  static REIMBURSEMENT_LIST_READ = "warranty.reimbursement.read";
  static REIMBURSEMENT_LIST_WRITE = "warranty.reimbursement.write";
  static REIMBURSEMENT_LIST_WRITE_CREATE =
    "warranty.reimbursement.write.create";
  static REIMBURSEMENT_LIST_WRITE_UPDATE =
    "warranty.reimbursement.write.update";
  static REIMBURSEMENT_LIST_WRITE_UPDATE_REMARK =
    "warranty.reimbursement.write.update.remark";
  static REIMBURSEMENT_LIST_WRITE_UPDATE_CONTACT_NUMBER =
    "warranty.reimbursement.write.update.contact-number";
  static REIMBURSEMENT_LIST_WRITE_UPDATE_COVERAGE_PERIOD =
    "warranty.reimbursement.write.update.coverage-period";
  static REIMBURSEMENT_LIST_WRITE_UPDATE_STATUS =
    "warranty.reimbursement.write.update.status";
}

class MessageBlasting {
  static MODULE = "message-blasting";

  static MESSAGE = "message-blasting.message";
  static MESSAGE_READ = "message-blasting.message.read";
  static MESSAGE_WRITE = "message-blasting.message.write";
  static MESSAGE_WRITE_CREATE = "message-blasting.message.write.create";
  static MESSAGE_WRITE_UPDATE = "message-blasting.message.write.update";
  static MESSAGE_WRITE_DELETE = "message-blasting.message.write.delete";

  static TEMPLATE = "message-blasting.template";
  static TEMPLATE_READ = "message-blasting.template.read";
  static TEMPLATE_WRITE = "message-blasting.template.write";
  static TEMPLATE_WRITE_CREATE = "message-blasting.template.write.create";
  static TEMPLATE_WRITE_UPDATE = "message-blasting.template.write.update";
  static TEMPLATE_WRITE_DELETE = "message-blasting.template.write.delete";
}

class OtpReporting {
  static MODULE = "otp-reporting";
}

class ChatAssistant {
  static MODULE = "chat-assistant";
}

export const AccessRights = {
  Branch,
  Campaign,
  CampaignV2,
  Survey,
  LoyaltyProgram,
  Company,
  Consumer,
  Counterfeit,
  Dashboard,
  DkshCustom,
  Employee,
  ExternalApi,
  Marketplace,
  OrganisationStructure,
  PhilipsCustom,
  PrifeCustom,
  Product,
  Qr,
  Reporting,
  StockOverview,
  TrackcoMobile,
  TrackcoPortal,
  Warranty,
  MessageBlasting,
  OtpReporting,
  ChatAssistant,
};